import { render } from "./RowComponent.vue?vue&type=template&id=13794cde"
import script from "./RowComponent.vue?vue&type=script&lang=js"
export * from "./RowComponent.vue?vue&type=script&lang=js"

import "./RowComponent.vue?vue&type=style&index=0&id=13794cde&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__